import { render, staticRenderFns } from "./FoundationPaymentPreview.vue?vue&type=template&id=070b38ba"
import script from "./FoundationPaymentPreview.vue?vue&type=script&lang=js"
export * from "./FoundationPaymentPreview.vue?vue&type=script&lang=js"
import style0 from "./FoundationPaymentPreview.vue?vue&type=style&index=0&id=070b38ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports